import { render, staticRenderFns } from "./Participate.vue?vue&type=template&id=6236411c"
import script from "./Participate.vue?vue&type=script&setup=true&lang=js"
export * from "./Participate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Participate.vue?vue&type=style&index=0&id=6236411c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports